import { Route } from '@direct-frontend/modules-router';
import { SettingsApiAsync } from '#pages/settings-api';
import { SettingsDomainAsync } from '#pages/settings-domain';
import { SettingsEmailNotificationsAsync } from '#pages/settings-email-notifications';
import { SettingsFeedbackAsync } from '#pages/settings-feedback';
import { SettingsIntegrationsAsync } from '#pages/settings-integrations';
import { SettingsInventoryAsync } from '#pages/settings-inventory';
import { SettingsLogisticsAsync } from '#pages/settings-logistics';
import { SettingsLogisticsWarehouseAsync } from '#pages/settings-logisticsWarehouse';
import { SettingsManagersAsync } from '#pages/settings-managers';
import { SettingsOrderAsync } from '#pages/settings-order';
import { SettingsOtherAsync } from '#pages/settings-other';
import { SettingsPaymentAsync } from '#pages/settings-payment';
import { SettingsSeoAsync } from '#pages/settings-seo';
import { SettingsTestOrder } from '#pages/settings-testOrder';
import { RedirectWithSearchParams } from '#shared/components/RedirectWithSearchParams';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import {
    settingsAboutRoute,
    settingsApiRoute,
    settingsDomainRoute,
    settingsEmailNotificationsRoute,
    settingsFeedbackRoute,
    settingsIntegrationsRoute,
    settingsInventoryRoute,
    settingsLogisticsRoute,
    settingsLogisticsWarehouseEditRoute,
    settingsManagersRoute,
    settingsOrderRoute,
    settingsOtherRoute,
    settingsPaymentRoute,
    settingsRoute,
    settingsSeoRoute,
    settingsTestOrderRoute,
} from '#shared/lib/routes';
import { SettingsLayout } from '../DashboardLayout';
import { SettingsAboutPageRoute } from './SettingsAboutPageRoute';

export const settingsRoutes = (isInternalYandexUser: boolean) =>
    renderWithPermission(
        'settings',
        'read',
        <>
            <Route path={settingsRoute.route} element={<SettingsLayout />}>
                <Route path={settingsAboutRoute.route} element={<SettingsAboutPageRoute />} />
                <Route path={settingsLogisticsRoute.route} element={<SettingsLogisticsAsync />} />
                <Route path={settingsLogisticsWarehouseEditRoute.route} element={<SettingsLogisticsWarehouseAsync />} />
                <Route path={settingsPaymentRoute.route} element={<SettingsPaymentAsync />} />
                <Route path={settingsManagersRoute.route} element={<SettingsManagersAsync />} />
                <Route path={settingsDomainRoute.route} element={<SettingsDomainAsync />} />
                <Route path={settingsSeoRoute.route} element={<SettingsSeoAsync />} />
                <Route path={settingsInventoryRoute.route} element={<SettingsInventoryAsync />} />
                <Route path={settingsOrderRoute.route} element={<SettingsOrderAsync />} />
                <Route path={settingsFeedbackRoute.route} element={<SettingsFeedbackAsync />} />
                <Route path={settingsApiRoute.route} element={<SettingsApiAsync />} />
                <Route path={settingsEmailNotificationsRoute.route} element={<SettingsEmailNotificationsAsync />} />
                {isInternalYandexUser && <Route path={settingsOtherRoute.route} element={<SettingsOtherAsync />} />}
                <Route path={settingsTestOrderRoute.route} element={<SettingsTestOrder />} />
                <Route
                    path={settingsRoute.route}
                    element={<RedirectWithSearchParams to={settingsAboutRoute.route} replace />}
                />
            </Route>
            <Route path={settingsIntegrationsRoute.route} element={<SettingsIntegrationsAsync />} />
        </>
    );
